import {createAsyncReducer} from '@telstra-connect/standard-actions/reducers'
import {
  ILoadFeatureFlagsAction,
  ILoadFeatureFlagsSuccessAction,
  ILoadFeatureFlagsErrorAction,
} from '../actions/load-feature-flags'
import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadFeatureFlagsAction =
  | ILoadFeatureFlagsAction
  | ILoadFeatureFlagsSuccessAction
  | ILoadFeatureFlagsErrorAction

const init = (state: IMobilityState, action: LoadFeatureFlagsAction) => ({
  ...state,
  featureFlagsData: {
    ...initialState.featureFlagsData,
    status: action.status,
  },
})

const success = (state: IMobilityState, action: LoadFeatureFlagsAction) => ({
  ...state,
  featureFlagsData: {
    ...initialState.featureFlagsData,
    status: action.status,
    data: (action as ILoadFeatureFlagsSuccessAction).data,
  },
})

const failure = (state: IMobilityState, action: LoadFeatureFlagsAction) => ({
  ...state,
  featureFlagsData: {
    ...initialState.featureFlagsData,
    status: action.status,
    error: (action as ILoadFeatureFlagsErrorAction).error,
  },
})

export const loadFeatureFlagsReducer = createAsyncReducer(initialState, init, success, failure)
